"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdColorPicker = require("cccisd-color-picker");
var _user = _interopRequireDefault(require("cccisd-icons/user"));
var _users = _interopRequireDefault(require("cccisd-icons/users4"));
var _database = _interopRequireDefault(require("cccisd-icons/database"));
var _stopwatch = _interopRequireDefault(require("cccisd-icons/stopwatch"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var CourseDescription = function CourseDescription(_ref) {
  var settings = _ref.settings,
    _ref$buttons = _ref.buttons,
    buttons = _ref$buttons === void 0 ? null : _ref$buttons;
  var pageWidth = settings.pageWidth,
    introduction = settings.introduction,
    learningObjectives = settings.learningObjectives,
    presenters = settings.presenters,
    acknowledgements = settings.acknowledgements,
    audience = settings.audience,
    creditHours = settings.creditHours,
    duration = settings.duration,
    finalTestInstructions = settings.finalTestInstructions,
    ceApprovalStatements = settings.ceApprovalStatements,
    specialAssistance = settings.specialAssistance,
    tableOfContents = settings.tableOfContents;
  var isIntroduction = introduction.main || introduction.courseSections.find(function (section) {
    return section.description || section.heading;
  });
  var isLearning = learningObjectives.sections.find(function (objective) {
    return objective.heading || objective.statement || objective.objectives.find(function (item) {
      return item.text;
    });
  });
  var isCeApproval = ceApprovalStatements.sections.find(function (statement) {
    return statement.title || statement.subtitle || statement.description;
  });
  var isFinalTest = finalTestInstructions.statement || finalTestInstructions.bullets.find(function (bullet) {
    return bullet.text;
  });
  var isCreditHours = creditHours.description;
  var isDuration = duration.description;
  var isSpecialAssistance = specialAssistance.content;
  var isAudience = audience.description;
  var isPresenters = presenters.sections.find(function (presenter) {
    return presenter.name || presenter.title || presenter.position || presenter.bio || presenter.image;
  });
  var isAcknowkledgements = acknowledgements === null || acknowledgements === void 0 ? void 0 : acknowledgements.content;
  var getPageWidth = function getPageWidth() {
    if (pageWidth === 'small') return '700px';
    if (pageWidth === 'large') return '1000px';
    return '850px';
  };
  var renderIconAndDescriptionField = function renderIconAndDescriptionField(field, defaultTitle, getDefaultIcon) {
    return field && field.description && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].section
    }, /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: field.title || defaultTitle
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].iconAndDescriptionContainer
    }, field.icon === 'default' && /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        color: (0, _cccisdColorPicker.getColor)(field.iconColor),
        fontSize: '30px',
        marginRight: '1em'
      }
    }, getDefaultIcon()), field.icon === 'upload' && field.imageDetails && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].backgroundImage,
      style: {
        backgroundImage: "url(".concat(field.imageDetails.url, ")")
      }
    }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: field.description
    }))));
  };
  var renderTableOfContents = function renderTableOfContents() {
    return tableOfContents && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].tableContent
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].newTable
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: "list-unstyled"
    }, isIntroduction && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#introduction-1"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: introduction.title || 'Introduction'
    }))), isLearning && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#objectives-2"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: learningObjectives.title || 'Learning Objectives'
    }))), isPresenters && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#presenters-3"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: presenters.title || 'Presenters'
    }))), isAudience && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#audience-4"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: audience.title || 'Audience'
    }))), isFinalTest && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#finaltest-5"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: finalTestInstructions.title || 'Final Test Instructions'
    }))), isCreditHours && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#credithours-6"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: creditHours.title || 'Credit Hours'
    }))), isDuration && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#duration-7"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: duration.title || 'Duration'
    }))), isCeApproval && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#ceapproval-8"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: ceApprovalStatements.title || 'CE Approval Statements'
    }))), isSpecialAssistance && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#specialassistance-9"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: specialAssistance.title || 'Special Assistance'
    }))), isAcknowkledgements && /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "#acknowledgements"
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: acknowledgements.title || 'Acknowledgements'
    }))))));
  };
  var isShowPresenterImages = presenters.sections.find(function (presenter) {
    return presenter.image;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].fullPage
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: getPageWidth()
    }
  }, isIntroduction && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "introduction-1"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: introduction.title || 'Introduction'
  })), introduction.main && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].mb3
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: introduction.main
  })), buttons && buttons(), introduction.courseSections.length > 0 && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, introduction.courseSections.filter(function (section) {
    return section.heading || section.description;
  }).map(function (section, i) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: section.key,
      className: "".concat(_style["default"].introductionSections, " ").concat(i % 2 === 0 && _style["default"].grayBg)
    }, section.heading && /*#__PURE__*/_react["default"].createElement("h5", null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content:
      // must include meta for cccisd plugins to work
      section.heading.meta ? section.heading : "<b>".concat(section.heading, "</b>")
    })), section.description && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: section.description
    }));
  }))), isLearning && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].section, " ").concat(_style["default"].learningObjectives)
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "objectives-2"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: learningObjectives.title || 'Learning Objectives'
  })), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, learningObjectives.sections.map(function (objectiveSection) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: objectiveSection.key,
      className: _style["default"].mb3
    }, objectiveSection.heading && /*#__PURE__*/_react["default"].createElement("h5", {
      className: _style["default"].mb2
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html
    // must include meta for cccisd plugins to work
    , {
      content: objectiveSection.heading.meta ? objectiveSection.heading : "<b>".concat(objectiveSection.heading, "</b>")
    })), objectiveSection.statement && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].mb2
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: objectiveSection.statement
    })), objectiveSection.objectives.find(function (objective) {
      return objective.text;
    }) && /*#__PURE__*/_react["default"].createElement("ul", {
      className: 'list-unstyled ' + _style["default"].bulletedList
    }, objectiveSection.objectives.map(function (objective) {
      return objective.text && /*#__PURE__*/_react["default"].createElement("li", {
        key: objective.key
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "".concat(_style["default"].mb2, " ").concat(_style["default"].bullet)
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: objective.text
      })));
    })));
  }))), isPresenters && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "presenters-3"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: presenters.title || 'Presenters'
  })), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled"
  }, presenters.sections.map(function (presenter) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: presenter.key,
      className: _style["default"].mb3
    }, presenter.image && /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        backgroundImage: "url(".concat(presenter.image.url, ")")
      },
      className: "".concat(_style["default"].backgroundImage, " ").concat(_style["default"].presenterImage, " ").concat(_style["default"].mb2)
    }), !presenter.image && isShowPresenterImages && /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_style["default"].backgroundImage, " ").concat(_style["default"].mb2, " ").concat(_style["default"].presenterImage, " ").concat(_style["default"].presenterPlaceholder)
    }, /*#__PURE__*/_react["default"].createElement(_user["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: isShowPresenterImages && _style["default"].presenterInfo
    }, presenter.name && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: presenter.name
    }), presenter.title && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: presenter.title
    }), presenter.position && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: presenter.position
    }), presenter.bio && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: presenter.bio
    })));
  }))), /*#__PURE__*/_react["default"].createElement("section", {
    id: "audience-4"
  }, renderIconAndDescriptionField(audience, 'Audience', function () {
    return /*#__PURE__*/_react["default"].createElement(_users["default"], null);
  })), isFinalTest && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "finaltest-5"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: finalTestInstructions.title || 'Final Test Instructions'
  })), finalTestInstructions.statement && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: finalTestInstructions.statement
  }), finalTestInstructions.bullets.find(function (bullet) {
    return bullet.text;
  }) && /*#__PURE__*/_react["default"].createElement("ul", {
    className: "list-unstyled ".concat(_style["default"].bulletedList)
  }, finalTestInstructions.bullets.map(function (bullet) {
    return bullet.text && /*#__PURE__*/_react["default"].createElement("li", {
      key: bullet.key
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "".concat(_style["default"].mb2, " ").concat(_style["default"].bullet)
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: bullet.text
    })));
  }))), /*#__PURE__*/_react["default"].createElement("section", {
    id: "credithours-6"
  }, renderIconAndDescriptionField(creditHours, 'Credit Hours', function () {
    return /*#__PURE__*/_react["default"].createElement(_database["default"], null);
  })), /*#__PURE__*/_react["default"].createElement("section", {
    id: "duration-7"
  }, renderIconAndDescriptionField(duration, 'Duration', function () {
    return /*#__PURE__*/_react["default"].createElement(_stopwatch["default"], null);
  })), isCeApproval && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "ceapproval-8"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: ceApprovalStatements.title || 'CE Approval Statements'
  })), ceApprovalStatements.sections.map(function (statement) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].mb3,
      key: statement.key
    }, statement.title && /*#__PURE__*/_react["default"].createElement("h5", {
      className: _style["default"].mb1
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html
    // must include meta for cccisd plugins to work
    , {
      content: statement.title.meta ? statement.title : "<b>".concat(statement.title, "</b>")
    })), statement.subtitle && /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].mb1
    }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html
    // must include meta for cccisd plugins to work
    , {
      content: statement.subtitle.meta ? statement.subtitle : "<i>".concat(statement.subtitle, "</i>")
    })), statement.description && /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
      content: statement.description
    }));
  })), isSpecialAssistance && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "specialassistance-9"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: specialAssistance.title || 'Special Assistance'
  })), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: specialAssistance.content
  })), isAcknowkledgements && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, acknowledgements.displayInModal ? /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: acknowledgements.title || 'Acknowledgements',
    trigger: /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-primary",
      id: "acknowledgements"
    }, acknowledgements.title || 'Acknowledgements'),
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: acknowledgements.content
  })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", {
    id: "acknowledgements"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: acknowledgements.title || 'Acknowledgements'
  })), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: acknowledgements.content
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].stickyTable
  }, renderTableOfContents())));
};
var _default = exports["default"] = CourseDescription;